import { isPolygonOrMultiPolygon } from "../../geometry_utilities";
import type { Feature, Geometry } from "geojson";

export type SiteMVTFeatureProperties = {
  id: string;
  stage: string;
  shared: boolean;
  layerName: "sites";
};

export type SiteMVTFeature = Feature<Geometry, SiteMVTFeatureProperties>;

export function isSiteBoundary(feature: any): feature is SiteMVTFeature {
  const hasValidGeometry = isPolygonOrMultiPolygon(feature?.geometry);
  const hasValidProperties = feature?.properties?.id && feature?.properties?.layerName === "sites";

  return hasValidGeometry && hasValidProperties;
}
